import {
    forwardRef,
    useImperativeHandle,
} from 'react'

const Welcome = forwardRef(({ company, handleNext }, ref) => {

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                },
            }
        },
    }))

    return (
        <div className="flex flex-col items-center justify-center px-4 py-10">
            <div className="max-w-3xl w-full bg-white shadow-xl rounded-2xl p-8 space-y-6">
                <div className="space-y-2 text-center">
                    <h1 className="text-3xl font-bold text-gray-800">Welcome!</h1>
                    <p className="text-lg text-gray-600">
                        Ready to begin your background check?
                    </p>
                </div>

                <div className="text-gray-700 text-base space-y-4">
                    <p>
                        Thank you for your application with <span className="font-semibold text-gray-800">{company?.name}</span>. We're using <span className="font-semibold">VerifiedID</span> to conduct a secure and standard pre-employment background check.
                    </p>

                    <div className="bg-gray-100 rounded-lg p-4 space-y-2">
                        <p className="font-semibold text-gray-800">Here's a quick overview of the process:</p>
                        <ul className="list-disc list-inside space-y-1 text-gray-700">
                            <li><strong>Agree to Electronic Forms:</strong> Confirm your consent to electronic documents and signatures.</li>
                            <li><strong>Review Legal Disclosures:</strong> Read important information about the background check and your rights.</li>
                            <li><strong>Authorize Checks:</strong> Grant specific permission for each type of check needed for your role.</li>
                            <li><strong>Provide Your Information:</strong> Securely enter your personal, work, and education details.</li>
                            <li><strong>Submit:</strong> Send your information for processing.</li>
                        </ul>
                    </div>

                    <p className="text-sm text-gray-700 italic">
                        <strong>Note:</strong> Please do not use your browser's back button. You’ll review everything before submitting.
                    </p>
                </div>

                <div className="text-center">
                    <button
                        className="mt-4 px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg shadow-md transition-all"
                        onClick={handleNext}
                    >
                        Start Background Check
                    </button>
                </div>
            </div>
        </div>
    )

})

export default Welcome
